import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "../ui/dialog";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Warehouse } from "lucide-react";

/**
 * Juni-2026 (User-Wunsch) — Popup zum Markieren des Lager-Status bei Neufahrzeugen.
 * Ersetzt den früheren inline-Block in der Disposition. Optionen:
 *   - vorlauf  = Vorgemerkt / im Anflug
 *   - bestand  = Sofort verfügbar
 *   - bestell  = Erst auf Bestellung
 */
export const STOCK_STATE_OPTIONS = [
    { value: "vorlauf", label: "Vorlauf", desc: "Vorgemerkt / im Anflug" },
    { value: "bestand", label: "Bestand", desc: "Sofort verfügbar" },
    { value: "bestell", label: "Bestellung", desc: "Erst auf Bestellung" },
];

export const STOCK_STATE_LABELS = {
    vorlauf: "Vorlauf",
    bestand: "Bestand",
    bestell: "Bestellung",
};

export function StockStatusModal({ open, onOpenChange, form, update }) {
    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="sm:max-w-lg rounded-sm" data-testid="stock-status-modal">
                <DialogHeader>
                    <DialogTitle className="flex items-center gap-2">
                        <Warehouse className="w-5 h-5 text-amber-600" /> Lager-Status (Neufahrzeug)
                    </DialogTitle>
                    <DialogDescription>
                        Markiere den Lager-Status dieses Neufahrzeugs. Die Auswahl wird neben dem Zustand angezeigt.
                    </DialogDescription>
                </DialogHeader>

                <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 mt-1">
                    {STOCK_STATE_OPTIONS.map((opt) => (
                        <button
                            type="button"
                            key={opt.value}
                            onClick={() => update("stock_state", opt.value)}
                            className={`text-left cursor-pointer rounded-sm border-2 px-3 py-2.5 text-xs transition-colors ${
                                (form.stock_state || "") === opt.value
                                    ? "border-amber-600 bg-amber-50 shadow-sm"
                                    : "border-gray-200 bg-white hover:border-amber-400"
                            }`}
                            data-testid={`stock-modal-state-${opt.value}`}
                        >
                            <div className="font-bold text-amber-900">{opt.label}</div>
                            <div className="text-[10px] text-gray-600 mt-0.5">{opt.desc}</div>
                        </button>
                    ))}
                </div>

                {form.stock_state && (
                    <div className="flex items-center gap-3 mt-3 pt-3 border-t border-gray-100" data-testid="stock-modal-count-row">
                        <Label className="text-[11px] font-bold uppercase tracking-wider text-gray-600 shrink-0">Stückzahl</Label>
                        <Input
                            type="number"
                            min="0"
                            max="9999"
                            value={form.stock_count ?? ""}
                            onChange={(e) => update("stock_count", e.target.value)}
                            placeholder="z. B. 3"
                            className="max-w-[160px] rounded-sm font-mono-num"
                            data-testid="stock-modal-count"
                        />
                        <span className="text-[11px] text-gray-500">Wird Käufern als „X im {STOCK_STATE_LABELS[form.stock_state] || "Bestand"}" angezeigt.</span>
                    </div>
                )}

                <DialogFooter className="mt-2 gap-2">
                    {form.stock_state && (
                        <Button
                            type="button"
                            variant="ghost"
                            onClick={() => { update("stock_state", ""); update("stock_count", ""); }}
                            className="rounded-sm text-gray-500 hover:text-red-600"
                            data-testid="stock-modal-clear"
                        >
                            Status entfernen
                        </Button>
                    )}
                    <Button
                        type="button"
                        onClick={() => onOpenChange(false)}
                        className="rounded-sm bg-[#111827] hover:bg-black text-white"
                        data-testid="stock-modal-confirm"
                    >
                        Übernehmen
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
